import React from 'react';
import { Global } from '@emotion/react';
import top from '@/assets/hyperbet/images/background/bg.png';

export default function index() {
  return (
    <Global
      styles={{
        body: {
          backgroundImage: `url(${top}), linear-gradient(180deg, #1C242D 0%, #131A21 100%)`,
          backgroundPosition: 'top, center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          '@media (max-width: 767px)': {
            background: `linear-gradient(180deg, #1C242D 0%, #131A21 100%)`,
          },
        },
      }}
    />
  );
}
